<template>
   <dashboard-layout>
       <div class="sh-mainpanel"> 
            <div class="sh-pagetitle">
                <div class="input-group">
                <!-- <input type="search" class="form-control" placeholder="Search"> -->
                <span class="input-group-btn">
                    <!-- <button class="btn"><i class="fa fa-search"></i></button> -->
                </span><!-- input-group-btn -->
                </div><!-- input-group -->
                <div class="sh-pagetitle-left">
                <!-- <div class="sh-pagetitle-icon"><i class="icon ion-ios-home"></i></div> -->
                <div class="sh-pagetitle-title"> 
                    <h2>Nieuwe Order</h2>
                </div><!-- sh-pagetitle-left-title -->
                </div><!-- sh-pagetitle-left -->
            </div><!-- sh-pagetitle -->

            <div class="sh-pagebody">
                <div class="row row-sm">
                    <div class="col-12">
                        <div class="outer">
                            <div class="inner bg-container">
                                <div class="card">
                                    <div class="card-header bg-primary tx-white">
                                        <a href="/create-debtor" class="float-right btn btn-success">
                                            <i class="fa fa-plus"></i> Organisatie Aanmaken
                                        </a>
                                    </div>
                                    <div class="" v-if="loading.status">
                                        <div class="d-flex bg-gray-200 ht-300 pos-relative align-items-center">
                                            <div class="sk-rotating-plane bg-gray-800"></div>
                                        </div>
                                    </div>
                                    <div v-else class="card-block m-t-35 pd-sm-30">
                                        <div class="row">
                                            <div class="col-lg">
                                                <!-- <select v-model="order_id" id="searchOrg" name="state" class="form-control">
                                                    <option></option>
                                                    <option v-for="(org,index) in organizations" :key="index" :value="org.id">{{org.name}}</option> 
                                                </select>  -->
                                                <v-select v-model="order_id" :options="organizations" :reduce="d=>d.id" label="name"></v-select>
                                                <br>

                                                <button @click="createOrder()" class="btn btn-success">Maak nieuwe order</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /.inner -->
                        </div>

                    </div>
                    
                </div>
            </div>
       </div>
   </dashboard-layout>
</template>

<script>
import dashboardLayout from '../layouts/dashboard_layout'

import { mapState } from 'vuex'
export default {
    name:'create_order',
    components:{
        dashboardLayout
    },
    computed:{
        ...mapState({
            loading:(state)=>state.loading,
            endpoint:(state)=>state.endpoint,
        }),
    },
    data(){
        return {
            organizations:[],
            order_id:0, 
        }
    },
    created(){
        this.$store.state.loading.status=true;
        this.$store.dispatch('get',this.endpoint+'vue/order/organizations')
        .then((data)=>{
            console.log(data);
            this.organizations=data.data; 
            this.$store.state.loading.status=false; 
        })
        .catch((error)=>{
            console.log(error.request);
            this.$store.state.loading.status=false;
        })
    },
    methods:{
        createOrder(){  
            this.$store.state.loading.status=true;
            this.$store.dispatch('post',{details:{order_id:this.order_id},endpoint:this.endpoint+'vue/order/'+this.order_id})
            .then((data)=>{
                console.log(data);
                this.$store.state.loading.status=false;
                window.location.href="edit-order/"+data.data.id;
            })
            .catch((error)=>{
                console.log(error.request);
                this.$store.state.loading.status=false;
            });
        },
    }
}
</script>